<!-- Preloader Start -->
<!--<div id="preloader-active">-->
<!--  <div class="preloader d-flex align-items-center justify-content-center">-->
<!--    <div class="preloader-inner position-relative">-->
<!--      <div class="preloader-circle"></div>-->
<!--      <div class="preloader-img pere-text">-->
<!--        <img src="assets/img/23232.png" alt="">-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
<!-- Preloader Start -->
<header>
  <!-- Header Start -->
  <div class="header-area header-transparrent bg-white ">

    <div class="navy-bar d-flex flex-row justify-content-start">
      <div>
        <span class="lang">  العربية</span>

      </div>
      <div class="col-md-8 text-center">

        <span class="header-text">لطلب نسخة تجريبية     info@tracllo.com </span>

      </div>






    </div>

    <div class="main-header header-sticky" dir="ltr">
      <div class="bg-white">
        <div class="row m-0">
          <!-- Logo -->
          <div class="col-xl-2 col-lg-2 col-md-2">
            <div class="logo-section">
              <div><a routerLink="/"><img src="../../assets/img/23232.png" class="logo" alt=""></a></div>
              <div class="logo-desc text-center">Tracllo</div>
            </div>
          </div>
          <div class="col-xl-9 col-lg-9 col-md-9 mobile">
            <!-- Main-menu -->
            <div  class="main-menu-home  m-63 f-right d-none d-lg-block d-flex align-items-center">
              <nav>
                <ul id="navigation">
                  <li class="green-text"><a (click)="goToDiv('home')"> Hello !</a></li>
                  <li class="green-text"><a (click)="goToDiv('about')">About Us</a></li>
                  <li class="green-text"><a (click)="goToDiv('products')">Products &amp; Solutions</a></li>
                  <li class="green-text"><a href="privacy">Privacy</a></li>
                  <li class="">
                    <div class="contact-button">
                      <a class="text-white">CONTACT</a>
                    </div>
                  </li>

                </ul>
              </nav>
            </div>
          </div>

          <!-- Mobile Menu -->
          <div class="col-12">
            <div class="mobile_menu d-block d-lg-none"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Header End -->
</header>
<main class="bg-white">

  <!-- Slider Area Start-->
  <div class="slider-area  slider-area-bg " id="home">
    <div class="slider-active pb-5">
      <div class="single-slider slider-height d-flex align-items-center" >
        <div class="container">
          <div class="row d-flex align-items-center">
            <div class="col-lg-12 col-md-12">
              <div class="into-header">Welcome to Tracllo</div>
              <div class="sub-header-text">Our goal is to organize transportation and mobility management and build modern technology for a different future. </div>
              <a class=""  (click)="goToDiv('about')"><span class="who-are ">who are we </span>
              </a>
            </div>

          </div>

        </div>
      </div>
    </div>

  </div>

  <div class="slider-area pt-5 mt-2 about-us-bg" id="about">
    <div class="slider-active">
      <div class="single-slider slider-height d-flex align-items-start ">
        <div class="container">
          <div class="row d-flex align-items-center">
            <div class="col-lg-12     col-md-12 ">
              <div class="hero__caption">
                <h1 data-animation="fadeInLeft" class="mb-0  text-center mt-5" data-delay=".4s">
                  About Us

                </h1>
                <div class="font-weight-bold">
                  <span class="font-18">A company working to produce applications for tracking technology for cars, buses, people, etc., and </span><br/><span class=""> the main goal is to create tools that help in achieving the highest benefit from tracking technology</span>
                </div>

                <!-- Hero-btn -->

              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- Slider Area End-->
  <!-- What We do start-->
  <div class="what-we-do we-padding bg-white navy-text" id="products">
    <div class="container">
      <!-- Section-tittle -->
      <div class="row d-flex justify-content-center">
        <div class="col-lg-12">
          <div class="section-tittle text-center">
            <h2 class=" text-center font-79">Our Products    </h2>
          </div>
          <div class="row mb-5">
            <div class="col-md-6 mt-5 mb-3">

              <div class="title-head font-weight-bold">Traffic management for the educational institution</div>
              <div class="text-right font-18">Educational institutions will be able to manage the mobility process for students, by arranging return and return trips for students, distributing students to buses, tracking students and drivers, and securing the movement of students, and the system helps the institution provide buses and manage the resources of the institution.</div>
              <div class="font-18 dark-green mt-5 text-right font-weight-bold">Available on all platforms</div><div style="
    margin-top: 12px;
    text-align: left;
"><span class="badge-circle">ANDROID</span><span class="badge-circle">IOS</span><span class="badge-circle">WEB</span><span class="badge-circle">TABLET</span>
         </div>
              <div style="
    margin-top: 45px;
    margin-bottom: 8px;
    text-align: left;
"><a href="/login" class="learn-more-btn">Go To Dashboard</a>
<!--                <a href="http://clinic.medlinic.com/register" class="down-btn ml-20">Request Demo</a>-->
                </div>





















            </div>
            <div class="col-md-6 screen-img">
              <!--                                <img src="./assets/img/screen.png" class="w-100"/>-->
            </div>

          </div>

        </div>
      </div>
    </div>


  </div>
  <div class="what-we-do we-padding bg-white  " id="clients">
    <div class="container">
      <!-- Section-tittle -->
      <div class="row d-flex justify-content-center" dir="ltr">
        <div class="col-lg-12">
          <div class="section-tittle text-center">
            <h2 class="navy-text text-center">Services provided to the institution</h2>
          </div>

          <div class="row mb-5 text-center">

            <div class="col-lg-3  col-md-3" *ngFor="let item of services">
              <div [ngStyle]="{   background: item.background,color:item.color}" style="
    text-align: left !important;

    padding: 29px;
    border: 0;
    margin-bottom: 20px;
    box-shadow: 0 0px 5px 2px rgba(171,184,243,.26);
    ">
                <div style="
    font-weight: bold;
    font-size: 31px;
">{{item.title}}</div>



              </div>
            </div>


          </div>


        </div>
      </div>


      <div class="row mb-5 pb-5">

        <div class="col-md-6 driver-app">
          <!--                                <img src="./assets/img/screen.png" class="w-100"/>-->
        </div>
        <div class="col-md-6 mt-5 mb-3">

          <div class="title-head font-weight-bold" style="font-size: 51px">Bus and driver tracking system</div>
          <div class="font-18 dark-green mt-5 text-right font-weight-bold">Available on all platforms</div><div style="
    margin-top: 12px;
    text-align: left;
"><span class="badge-circle">ANDROID</span><span class="badge-circle">IOS</span><span class="badge-circle">TABLET</span>
        </div>
          <div style="
    margin-top: 45px;
    margin-bottom: 8px;
    text-align: left;
"><a href="http://clinic.medlinic.com/" class="down-btn">Download Now apple</a><a href="https://play.google.com/store/apps/details?id=com.tracllodriver" class="down-btn ml-20">Download Now android</a></div>





















        </div>
      </div>

      <div class="row mb-5 pb-5 bg-white">

        <div class="col-md-6 mt-5 mb-3">

          <div class="title-head font-weight-bold" style="font-size: 51px">Student reservation application</div>
          <div class="font-18 dark-green mt-5 text-right font-weight-bold">Available on all platforms</div><div style="
    margin-top: 12px;
    text-align: left;
"><span class="badge-circle">ANDROID</span><span class="badge-circle">IOS</span><span class="badge-circle">TABLET</span>
        </div>
          <div style="
    margin-top: 45px;
    margin-bottom: 8px;
    text-align: left;
"><a href="http://clinic.medlinic.com/" class="down-btn">Download Now apple</a><a href="https://play.google.com/store/apps/details?id=com.tracllo" class="down-btn ml-20">Download Now android</a></div>





















        </div>

        <div class="col-md-6 student-app">
          <!--                                <img src="./assets/img/screen.png" class="w-100"/>-->
        </div>
      </div>
    </div>


  </div>

  <div class="back-g-img">

  </div>






  <!-- We Create End -->




  <!-- have-project Start-->

  <!-- have-project End -->

</main>
<footer class="text-white" id="contact" dir="ltr">

  <div class=" col-lg-12   mb-5 pb-5" >
    <div class="row">
      <div class="d-flex flex-column col-lg-2">
        <div class="text-center">
          <img src="../../assets/img/23232.png" style="margin: unset!important;" class="logo width-121" >
        </div>
        <div class="text-white text-center mt-3"><span class="" style="font-size: 30px">Tracllo</span></div>
      </div>
      <div class="d-flex flex-column col-lg-4">
        <div class="mb-5">
          <h2 class="text-white">Quick Links</h2>
        </div>
        <div class="text-white font-12 mb-2"><a href="https://play.google.com/store/apps/details?id=com.tracllo">Tracllo for student app on Google store</a></div>
        <div class="text-white font-12 mb-2"><a href="https://play.google.com/store/apps/details?id=com.tracllodriver">Tracllo for Driver app on Google store</a></div>
        <div class="text-white font-12 mb-2"><a href="http://tracllo.com/login">Tracllo System on browsers</a></div>
         </div>

      <div class="d-flex flex-column col-lg-4">
        <div class="mb-5">
          <h2 class="text-white">Contact Information</h2>
        </div>
        <div class="text-white font-18   mb-2"><span>Jordan, Amman</span></div>
        <div class="text-white font-14 mb-1"><span>Queen Rania Street</span></div>
        <div class="text-white font-14  mb-3"><span>Opposite to Al Fanar Hotel - Qandil Building</span></div>
        <div class="text-white font-18  mb-2"><span>E : info@tracllo.com</span></div>
        <div class="text-white font-18  mb-2"><span>P : +963798981681</span></div>

      </div>
    </div>
  </div>




</footer>
<div class="" style="  background: #787bff;   padding: 30px;" dir="ltr">
  <div class="d-flex flex-row">
    <div class="">
      <img src="./assets/img/23232.png" class="ml-4" style="  width: 50px;border-radius: 100%;    border: 2px solid #ffffff;">

    </div>
    <div class="d-flex align-items-center flex-column justify-content-center  w-100">
<!--      <div class="d-flex flex-row">-->
<!--        <a href="https://web.facebook.com/Medlinic" class="facebook icon-social">-->
<!--          <i class="fa fa-facebook-f"></i>-->
<!--          <span>Facebook</span>-->
<!--        </a>-->
<!--        <a href="http://wa.me/9627985100278" class="twitter icon-social">-->
<!--          <i class="fa fa-whatsapp"></i>-->
<!--          <span>WhatApp</span>-->
<!--        </a>-->
<!--        <a href="https://www.instagram.com/medlinic" class="twitter icon-social">-->
<!--          <i class="fa fa-instagram"></i>-->
<!--          <span>Instagram</span>-->
<!--        </a>-->
<!--      </div>-->
      <div>

        <small class="text-white">&copy; Copyright 2020, <span class="">powered by Tracllo</span></small>


      </div>

    </div>


  </div>
</div>
